import { create } from 'zustand';
import { ThemeType } from '../types/command';

interface ThemeState {
  theme: ThemeType;
  setTheme: (theme: ThemeType) => void;
}

export const useThemeStore = create<ThemeState>((set) => ({
  theme: (localStorage.getItem('preferred-theme') as ThemeType) || 'cmd',
  setTheme: (theme: ThemeType) => set({ theme })
})); 